/*
 * @Author: w9013327 v-maijiahua@oppo.com
 * @Date: 2022-11-01 18:26:49
 * @LastEditors: jordan.lu jordan.lu@oppo.com
 * @LastEditTime: 2024-01-23 16:48:05
 * @FilePath: \sns-user-frontend\src\service\ugc.js
 * @Description: UGC
 */
import { get, post } from './http'

const ugcPath = 'ugc/frontend/'
const UGC = {
  // 获取搜索帖子列表
  getSearchThread: (params) => {
    return get(`${ugcPath}search/thread`, params)
  },
  // 获取帖子详情
  getThreadInfo: (params) => {
    return get(`${ugcPath}thread/get`, params)
  },
  onView: (params) => {
    return post(`${ugcPath}thread/view/stat`, params)
  },
  // 获取我的关注帖子卡片列表
  getMyFollowingThread: (params) => {
    return get(`${ugcPath}thread/threadDynamic`, params)
  },
  // 获取我的关注评论卡片列表
  getMyFollowingPost: (params) => {
    return get(`${ugcPath}comment/commentDynamic`, params)
  },
  // 获取热搜词
  getHotTag: (params) => {
    return get(`${ugcPath}hot/list`, params)
  },
  // 获取搜索广告
  getSearchAds: () => {
    return get('/operate/frontend/searchBanner/ads')
  },
  // 获取搜索关键词推荐
  getSearchKeyword: (params) => {
    return get('/operate/frontend/searchBanner/keyword', params)
  },
  // 点赞
  like: (params, type = 'thread') => {
    params.needAuth = true
    params.needToastErr = true
    return post(`${ugcPath}${type}/praise/add`, params)
  },
  // 取消点赞
  unlike: (params, type = 'thread') => {
    params.needAuth = true
    params.needToastErr = true
    return post(`${ugcPath}${type}/praise/cancel`, params)
  },
  // 帖子投票
  onPoll: (params) => {
    params.needAuth = true
    return post(`${ugcPath}thread/poll/vote`, params)
  },
  // 评论列表
  getCommentList: (params) => {
    return get(`${ugcPath}comment/query`, params)
  },
  // 删除帖子
  deleteThread: (params) => {
    params.needAuth = true
    return post(`${ugcPath}thread/delete`, params)
  },
  // 获取评论
  getComment: (params) => {
    return get(`${ugcPath}comment/get`, params)
  },
  // 获取回复
  getReplyList: (params) => {
    return get(`${ugcPath}comment/query/reply`, params)
  },
  // 获取回复页数
  queryReplyPage: (params) => {
    return get(`${ugcPath}comment/getWithPage`, params)
  },
  // 评论置顶
  commentstick: (params) => {
    params.needAuth = true
    return post(`${ugcPath}comment/stick/add`, params)
  },
  // 取消评论置顶
  commentcancelStick: (params) => {
    params.needAuth = true
    return post(`${ugcPath}comment/stick/cancel`, params)
  },
  // 评论删除
  deleteComment: (params) => {
    params.needAuth = true
    return post(`${ugcPath}comment/delete`, params)
  },
  // 创建附件
  createAttachs: (params) => {
    params.needAuth = true
    return post(`${ugcPath}attachment/create`, params)
  },
  // 发布帖子
  postThread: (params, type, requestType = 'create') => {
    params.needAuth = true
    let createType = ''
    switch (type) {
      case 'article':
        createType = 'long'
        break
      case 'moment':
        createType = 'short'
        break
      case 'poll':
        createType = 'poll'
        break
      default:
    }
    return post(`${ugcPath}thread/${requestType}/${createType}`, params)
  },
  // 发布/更新 评论
  comment: (params, requestType = 'create') => {
    params.needAuth = true
    params.needToastErr = true
    return post(`${ugcPath}comment/${requestType}`, params)
  },
  // 查询草稿数量
  getDraftQuantity: (params) => {
    return get(`${ugcPath}draft/thread/get/count`, params)
  },
  // 查询帖子草稿列表
  getDraftList: (params) => {
    params.needAuth = true
    return get(`${ugcPath}draft/thread/gets`, params)
  },
  // 查询草稿详情
  getDraftDetails: (params) => {
    params.needAuth = true
    return get(`${ugcPath}draft/thread/get`, params)
  },
  // 保存草稿
  saveDraft: (params) => {
    params.needAuth = true
    return post(`${ugcPath}draft/thread/add`, params)
  },
  // 删除草稿
  delDraft: (params) => {
    params.needAuth = true
    return post(`${ugcPath}draft/thread/delete`, params)
  },
  // mark评论
  markComment: (params) => {
    params.needAuth = true
    return post(`${ugcPath}comment/mark/add`, params)
  },
  // 取消mark评论
  unMarkComment: (params) => {
    params.needAuth = true
    return post(`${ugcPath}comment/mark/cancel`, params)
  },
  // 关闭帖子评论
  closeComment: (params) => {
    params.needAuth = true
    return post(`${ugcPath}thread/buff/muted`, params)
  },
  // 开启帖子评论
  openComment: (params) => {
    params.needAuth = true
    return post(`${ugcPath}thread/buff/open`, params)
  },
  // 隐藏帖子
  hideThread: (params) => {
    params.needAuth = true
    return post(`${ugcPath}thread/explore/hide`, params)
  },
  // 显示帖子
  showThread: (params) => {
    params.needAuth = true
    return post(`${ugcPath}thread/explore/show`, params)
  },
  // 移动帖子
  moveThread: (params) => {
    params.needAuth = true
    return post(`${ugcPath}thread/move`, params)
  },
  // 获取所有分类Label
  getAllLabels: (params) => {
    params.needAuth = true
    return get(`${ugcPath}label/category/get`, params)
  },
  // 新增Label
  addLabel: (params) => {
    params.needAuth = true
    return post(`${ugcPath}label/record/add`, params)
  },
  // 修改Label
  updateLabel: (params) => {
    params.needAuth = true
    return post(`${ugcPath}label/record/update`, params)
  },
  // 获取帖子所有Label
  getThreadLabels: (params) => {
    params.needAuth = true
    return get(`${ugcPath}label/record/get`, params)
  },
  // 获取帖子所有Media
  getThreadMedia: (params) => {
    params.needAuth = true
    return get(`${ugcPath}label/record/check`, params)
  },
  // 精选
  highlightOn: (params) => {
    params.needAuth = true
    return post(`${ugcPath}thread/highlight/on`, params)
  },
  // 取消精选
  highlightOff: (params) => {
    params.needAuth = true
    return post(`${ugcPath}thread/highlight/off`, params)
  },
  // 检查帖子能否编辑
  checkThreadEdit: (params) => {
    return get(`${ugcPath}thread/check/update`, params)
  },
  // 隐藏评论
  hideComment: (params) => {
    return post(`${ugcPath}comment/hide`, params)
  },
  // 合并帖子
  mergeThread: (params) => {
    return post(`${ugcPath}thread/merge/add`, params)
  },
  // 取消合并
  cancleMergeThread: (params) => {
    return post(`${ugcPath}thread/merge/cancle`, params)
  },
  // 获取帖子状态
  getThreadStatus: (params) => {
    return get(`${ugcPath}thread/get/status`, params)
  },
  // 官方回复
  addVerified: (params) => {
    return post(`${ugcPath}comment/verified/add`, params)
  },
  // 取消官方回复
  cancelVerified: (params) => {
    return post(`${ugcPath}comment/verified/cancel`, params)
  },
  // 添加精选
  addFeatured: (params) => {
    return post(`${ugcPath}comment/featured/add`, params)
  },
  // 取消精选
  cancelFeatured: (params) => {
    return post(`${ugcPath}comment/featured/cancel`, params)
  }
}

export default UGC